import { useEffect, useMemo, useState } from "react";
import { apiClient } from "../lib/apiClient";
import { ChangesData, changeKindsById, changedCount, resolveVisitSince } from "../lib/changes";

// useChanges: what changed in the county since the user's last visit (#3207).
// One request per county per tab session; a failure just means no badges.
export function useChanges(countyId: string, enabled: boolean) {
  const [data, setData] = useState<ChangesData | null>(null);

  useEffect(() => {
    if (!enabled || !countyId) {
      setData(null);
      return;
    }
    let cancelled = false;
    const since = resolveVisitSince();
    apiClient
      .get<{ data: ChangesData }>("/changes", { params: { countyId, since } })
      .then(({ data: body }) => {
        if (!cancelled) setData(body.data);
      })
      .catch(() => {
        if (!cancelled) setData(null);
      });
    return () => {
      cancelled = true;
    };
  }, [countyId, enabled]);

  const kindsById = useMemo(() => changeKindsById(data), [data]);
  const count = useMemo(() => changedCount(data), [data]);
  return { kindsById, count, since: data?.since ?? null };
}
